import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { CustomerStatusEnum } from '../enums/customer-status.enum';
import { CustomerTypeEnum } from '../enums/customer-type.enum';

/**
 * Customer filters
 */
export class CustomersFilters extends ApiRequestFilters {
	/**
	 * Countries id values
	 */
	countries?: number[];

	/**
	 * Status values
	 */
	statuses?: CustomerStatusEnum[];

	/**
	 * Record type values
	 */
	types?: CustomerTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
